export default "__VITE_ASSET__DWH7BtUe__"